function showResponseOptions() {

	var qresponseType = listArrays[allColumns.indexOf('responseType')][trialRow];
	var qresponseChoicesRaw = listArrays[allColumns.indexOf('responseOptions')][trialRow];
	var qresponseChoices = qresponseChoicesRaw.split(';').filter(function(c) {
		return c.length != 0
	});
	var qresponseChoicesRandomize = listArrays[allColumns.indexOf('responseOptionsRandom')][trialRow];
	if (qresponseType == 'box' || qresponseType == 'comment') {
		var separators = [';', ':'];
		qresponseChoices = qresponseChoicesRaw.split(new RegExp(separators.join('|'), 'g')).filter(function(c) {
			return c.length != 0
		});
	}
	var formInfo = {};
	formInfo.responseChoices = qresponseChoices;
	formInfo.multiLineSlider = false;
	formInfo.required = columnForTrial('required', trialRow) !== 'na' && columnForTrial('required', trialRow);
	formInfo.responseType = qresponseType;
	$('#responseContainer').css({'top': ""});

	console.log('qresponseType', qresponseType);

	switch (qresponseType) {
		//  	case "na":
		//    	break;
		// case "buttons":
			// break;

		case "label":
			showResponseLabels(formInfo);
			break;
		case "mic":
			enableMicResponse(clickGeneral);
			break;
		case "clicks":
			enableClickResponse();
			break;
		case "box":
			showResponseBox2(formInfo);
			break;
		case "comment":
			showResponseComment(formInfo);
			break;
		case "drag":
			enableDraggableStims(window.trialRow);
			break;
		case "slider":
			var inputSlider = showResponseSlider(formInfo);

			setResponseTopPosition(); //compute where we should display the buttons
			document.getElementById("responseContainer").style.top = currentButtonTop + "px";

			var advanceButton = window.textScreens.general[window.language]['NEXT'];
			var submitControls = '<button class="btn btn-primary" type="button" style="font-size: 180%;margin-left: auto;margin-top: 96px;min-width: 200px;box-sizing: content-box;margin-right: auto;clear: both;display: block;" onclick="return clickSlider()">' + advanceButton + '</button>';
			// you cannot have buttons and slider required
			var showNextBtn = !formInfo.required && !trialHasButtonsActive(window.trialRow);

			// Adds a next button that calls save
			 if (columnForTrial('responseOptions', trialRow).indexOf('noButton') < 0 && showNextBtn ) {
				$('#responseContainer').append(submitControls);
			}

			$(".rangeFormat").ionRangeSlider(generateSliderOptions(inputSlider, function() {
				// slider is ready
				if (formInfo.hideStart) {
					$('.irs-slider').hide();
					$(".irs-bar-edge").hide();
				}

				if (window.columnForTrial('responseOptions', trialRow).indexOf('removeFill') >= 0) {
					$('.irs-bar').hide();
					$('.irs-bar-edge').hide();
				}

		        // set the start time
		        timeInMs = performance.now();
			}, function() {
				// slider was touched
				if(columnForTrial('responseOptions', trialRow).indexOf('noButton') < 0){
					!showNextBtn && $('#responseContainer').append(submitControls);
				}
			})); //start slider

			break;
	}
	if(qresponseType.indexOf('*')>0){
		var qresponseMultipleType = qresponseType.split('*');
		switch(qresponseMultipleType[0]){
			case "box":
				formInfo.count = parseInt(qresponseMultipleType[1]);
				showResponseBox2(formInfo);
				break;
		}
	}
}


function hasClicksOptions() {
	return listTrialResponseOptions[window.trialRow] && (listTrialResponseOptions[window.trialRow].pixel || listTrialResponseOptions[window.trialRow].grid);
}
